//const Spinner = require('umbrella_core/components/spinner/Spinner');

class Bindings {

  constructor($elt) {
    this.$elt = $elt;
    this.bind();
  }

  bind() {

    // bind xhr link
    this.$elt.on('click', 'a[data-xhr-href], button[data-xhr-href]', (e) => {
      e.stopPropagation();
      e.preventDefault();

      const $target = $(e.currentTarget);
      const once = $target.data('once');
      const url = $target.data('xhr-href');
      const confirm = $target.data('confirm');
      const spinner = $target.data('spinner');

      if (once && $target.data('clicked')) {
        return false;
      }
      $target.data('clicked', true);

      if (confirm) {
        const modal = new ConfirmModal(confirm, () => {
          Api.GET(url, [], null, null, null, spinner);
        });
        modal.show();
      } else {
        Api.GET(url, [], null, null, null, spinner);
      }



      return false;
    });

    // bind xhr form
    this.$elt.on('submit', 'form[data-xhr-action]', (e) => {
      e.preventDefault();
      const $form = $(e.currentTarget);
      const once = $form.data('once');

      if (once && $form.data('submitted')) {
        return false;
      }
      $form.data('submitted', true);

      let formData = $form.serializeFiles();

      if (this.$submitButton !== undefined && this.$submitButton.name) {
        formData.append(this.$submitButton.name, this.$submitButton.value);
      }

      Api.ajax(
        $form.attr('method'),
        $form.data('xhr-action'),
        formData,
        (response) => { // success cb
          this.$elt.find('form[data-xhr-action]').trigger('xhr_form:success', response);
        },
        () => { // error cb
          this.$elt.find('form[data-xhr-action]').trigger('xhr_form:error');
        },
        () => { // error cb
          this.$elt.find('form[data-xhr-action]').trigger('xhr_form:complete');
        }
      );
    });

    // bind xhr buttons
    this.$elt.on('click', ':submit', (e) => {
      this.$submitButton = e.currentTarget;
    });

    // toastr
    if (typeof toastr !== 'undefined') {
      $('[data-toggle="toastr"]').each((i, elt) => {
        toastr[$(elt).data('type')]($(elt).html());
      });
    }

    // bind popover
    if (jQuery().popover) {
      $('[data-toggle="popover"]').popover({
        container: 'body'
      });
    }

    // open modal tv-compatible if query param TV=1
    $('document').ready(function() {

      if (location.search.indexOf('buying_guide=')>0 && location.search.indexOf('postid=') > 0)  {
        const urlParams = new URLSearchParams(location.search);
        const postid = urlParams.get('postid');
        const blocid = urlParams.get('buying_guide');

        Api.GET(`/wp-admin/admin-ajax.php?action=buying_guide&blocid=${blocid}&postid=${postid}`, [], null, null, null, '');
      }

      if (location.search.indexOf('TV=') > 0) {
        Api.GET("/wp-admin/admin-ajax.php?action=tv_compat_get_modal&marque=&taille=&fransat-connect=&definition-uhd=", [], null, null, null, '');
      }
      if (location.search.indexOf('TVs=') > 0) {
        Api.GET("/wp-admin/admin-ajax.php?action=tv_compat_get_modal_steps&marque=&taille=&fransat-connect=&definition-uhd=", [], null, null, null, '');
      }
    });


  }
}

module.exports = Bindings;
